var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"layout",staticClass:"left-layout",class:{show: _vm.show}},[_c('span',{staticClass:"hideLeft",on:{"click":_vm.hideLeft}},[_vm._v("\n    关闭\n    "),_c('i',{staticClass:"iconfont icon-guanbi"})]),_vm._v(" "),_c('div',{staticClass:"left-content"},[_c(_vm.cp,{tag:"component",attrs:{"params":_vm.args}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2a5717c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/page/layout/left.vue
// module id = null
// module chunks = 